import { useState } from 'react'

import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { Plus } from '@factorialco/f0-react/icons/app'
import { PerformanceFeedbacksReceivedDataCollectionDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import i18n from 'modules/core/lib/i18n'

import { cardVisualizations } from 'modules/performance_feedbacks/lib/cardVisualizations'
import { GiveFeedbackDialog } from 'modules/performance_feedbacks/components/GiveFeedbackDialog'

const ReceivedFeedback = () => {
  const { access } = useCurrentSession()
  const [dialogOpen, setDialogOpen] = useState(false)

  const source = useGraphqlDataCollectionSource({
    totalItemSummary: true,
    document: PerformanceFeedbacksReceivedDataCollectionDocument,
    paginationType: 'pages',
    perPage: 25,
    mapData: (data) => data.feedbacks.feedbackEntriesConnection.nodes || [],
    mapPagination: (data) => ({
      total: data.feedbacks.feedbackEntriesConnection.totalCount ?? 0,
    }),
    mapVariables: () => ({
      authorId: access.id,
    }),
    primaryActions: () => ({
      label: i18n.t('performance_feedbacks.pages.give_feedback.title'),
      icon: Plus,
      onClick: () => setDialogOpen(true),
    }),
  })

  return (
    <>
      {dialogOpen && <GiveFeedbackDialog onClose={() => setDialogOpen(false)} />}
      <OneDataCollection
        fullHeight
        source={source}
        emptyStates={{
          'no-data': {
            emoji: '💬',
            title: i18n.t('performance_feedbacks.empty_state.received_feedback.title_no_cta'),
            description: i18n.t(
              'performance_feedbacks.empty_state.received_feedback.description_no_cta'
            ),
          },
        }}
        visualizations={cardVisualizations('received')}
      />
    </>
  )
}

export default ReceivedFeedback
